<template>
    <div id="app">
        <component :is="layout"></component>
    </div>
</template>

<script>
    import CenteredBox from './layouts/CenteredBox';
    import Secured from './layouts/Secured';

    const DEFAULT_LAYOUT = 'Secured';

    export default {
        computed: {
            layout() {
                return this.$route.meta.layout || DEFAULT_LAYOUT;
            }
        },
        components: {
            CenteredBox,
            Secured
        }
    }
</script>

<style scoped lang="scss">
    #app {
        width: 100%;
        height: 100%;
    }
</style>
